import { useEffect } from 'react';
import tw from 'twin.macro';

import { useForm } from 'react-hook-form';

import { Button, Modal } from '@/components/base';
import { GetJobPositionsQuery } from '@/libs/graphql';

type JobPosition = GetJobPositionsQuery['getJobPositions'][number];

type FormValues = {
  title: string;
  jobDescriptions: string;
};

type Props = {
  mode: 'create' | 'edit';
  position?: JobPosition;
  loading?: boolean;
  onSubmit: (values: FormValues) => void;
  onClose: () => void;
};

const PositionFormModal = ({ mode, position, loading, onSubmit, onClose }: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { title: '', jobDescriptions: '' },
  });

  useEffect(() => {
    if (mode === 'edit' && position) {
      reset({ title: position.title, jobDescriptions: position.jobDescriptions });
    } else {
      reset({ title: '', jobDescriptions: '' });
    }
  }, [mode, position, reset]);

  const title = mode === 'create' ? 'เพิ่มตำแหน่งงาน' : 'แก้ไขตำแหน่งงาน';

  return (
    <Modal
      title={title}
      description={
        <form
          id="position-form"
          onSubmit={handleSubmit(onSubmit)}
          tw="flex flex-col gap-4 mt-2"
        >
          <label tw="flex flex-col gap-1">
            <span tw="font-semibold text-sm">ตำแหน่งงาน</span>
            <input
              tw="rounded-lg border bg-gray-50 px-3 py-2 focus:(bg-white outline-none ring-1 ring-primary)"
              placeholder="เช่น Software Engineer"
              {...register('title', { required: 'กรุณากรอกตำแหน่งงาน' })}
            />
            {errors.title && (
              <span tw="text-red-500 text-xs">{errors.title.message}</span>
            )}
          </label>
          <label tw="flex flex-col gap-1">
            <span tw="font-semibold text-sm">คำอธิบายงาน (สำหรับ AI)</span>
            <textarea
              tw="rounded-lg border bg-gray-50 px-3 py-2 focus:(bg-white outline-none ring-1 ring-primary) min-h-[120px] resize-y"
              placeholder="อธิบายรายละเอียดของตำแหน่งงาน เพื่อใช้ในการวิเคราะห์ผู้สมัคร..."
              {...register('jobDescriptions', { required: 'กรุณากรอกคำอธิบายงาน' })}
            />
            {errors.jobDescriptions && (
              <span tw="text-red-500 text-xs">{errors.jobDescriptions.message}</span>
            )}
          </label>
        </form>
      }
      primaryButtonText={mode === 'create' ? 'เพิ่ม' : 'บันทึก'}
      primaryButtonAction={() => handleSubmit(onSubmit)()}
      secondaryButtonText="ยกเลิก"
      secondaryButtonAction={onClose}
      loading={loading}
    />
  );
};

export default PositionFormModal;
